"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slide = function Slide(props) {
  var background = props.background,
      title = props.title,
      image = props.image,
      description = props.description,
      imageStyle = props.imageStyle,
      titleStyle = props.titleStyle,
      descriptionStyle = props.descriptionStyle,
      active = props.active,
      slideStyle = props.slideStyle;


  return _react2.default.createElement(
    "div",
    {
      className: "ris-slide " + (active ? "ris-slide-active" : "ris-slide-inactive"),
      style: _extends({}, slideStyle, { background: background })
    },
    _react2.default.createElement(
      "div",
      { className: "ris-slide-title-container" },
      _react2.default.createElement(
        "div",
        { className: "ris-slide-title", style: titleStyle },
        title
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "ris-slide-image-container" },
      _react2.default.createElement("img", {
        className: "ris-slide-image",
        alt: "slide",
        src: image,
        style: imageStyle
      })
    ),
    _react2.default.createElement(
      "div",
      { className: "ris-slide-description-container" },
      _react2.default.createElement(
        "div",
        { className: "ris-slide-description", style: descriptionStyle },
        description
      )
    )
  );
};

Slide.propTypes = {
  title: _propTypes2.default.string,
  image: _propTypes2.default.string,
  descriptionStyle: _propTypes2.default.object,
  titleStyle: _propTypes2.default.object,
  description: _propTypes2.default.string,
  imageStyle: _propTypes2.default.object,
  background: _propTypes2.default.string,
  active: _propTypes2.default.bool,
  slideStyle: _propTypes2.default.object
};

Slide.defaultProps = {
  title: "Title",
  image: "",
  description: "Description",
  background: "#ffeace",
  active: false
};

exports.default = Slide;